export const GOOGLE_ADDRESS_PARTS = {
  STREET_NUMBER: 'street_number',
  ROUTE: 'route',
  CITY: 'locality',
  STATE: 'administrative_area_level_1',
  ZIP_CODE: 'postal_code',
};
